<template>
  <div class="col-12 pl-0 ml-0 mt-5">
    <v-row>
      <v-col>
        <div class="d-flex">
          <p class="mb-0 title font-weight-light font-weight-bold mr-5">
            쇼핑몰 디자인 - 정품 인증 화면 만들기
          </p>
        </div>
        <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
          앱 어드민 <font class="font-weight-bold pl-0"> 상단 선택된 쇼핑몰(멀티샵) </font>의
          <font class="font-weight-bold pl-0"> PC 및 모바일 대표 디자인 스킨에 정품 인증 화면을 생성 </font>합니다.<br />
          <font class="font-weight-bold pl-0">반응형 디자인 스킨을 사용중인 경우</font> PC 쇼핑몰에 디자인 스킨이 사용되므로 PC 대표
          디자인에만 정품 인증 파일 생성을 하시면 됩니다.<br />
          <font class="font-weight-bold pl-0">아래의 버튼을 클릭하시면 정품 인증 화면이 만들어집니다.</font> (디자인 편집창 - registration
          폴더 및 파일 생성)<br />
          ‘정품 인증 파일 생성하기’ 버튼을 클릭하시면 registration 폴더 및 파일이 만들어지고, 이미 해당 폴더에 파일이 있는 경우 중복 생성이
          되지 않으니 참고해주세요.<br />
          (registration 폴더에 생성한 파일들을 직접 삭제한 경우 ‘정품 인증 파일 생성하기’ 버튼을 클릭하시면 삭제된 파일만 다시 생성됩니다.)
        </p>
      </v-col>
    </v-row>

    <v-btn class="blue darken-1 white--text mr-4 " width="330" @click="setDesign('PC')" large
      >PC 대표 디자인 - 정품 인증 파일 생성하기</v-btn
    >
    <v-btn class="blue darken-1 white--text " width="340" @click="setDesign('MOBILE')" large
      >모바일 대표 디자인 - 정품 인증 파일 생성하기</v-btn
    >
    <v-row class="mt-8">
      <v-col>
        <div class="d-flex">
          <p class="mb-0 title font-weight-light font-weight-bold mr-5">
            쇼핑몰 화면경로 추가하기
          </p>
        </div>
        <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
          [카페24 어드민 > 쇼핑몰 설정 > 사이트 설정 > 쇼핑몰 환경 설정]
          <font class="font-weight-light pl-0"> 메뉴로 이동한 후 설정해주세요.</font>
        </p>
        <ul>
          <li>PC탭의 ' <font class="font-weight-bold pl-0"> 화면경로 - 화면경로 설정 </font>' 을 클릭합니다.</li>
          <li>
            상품 폴더의 ‘ <font class="font-weight-bold pl-0"> 기획전 </font>’을 클릭하신 후 PC쇼핑몰, 모바일쇼핑몰 화면경로 설정에서 '
            <font class="font-weight-bold pl-0"> 화면 경로 추가</font>' 버튼을 클릭해주세요.
          </li>
          <li>
            화면 경로 추가 방법에 ‘ <font class="font-weight-bold pl-0"> 직접 선택</font>’ 선택하신 후, ‘
            <font class="font-weight-bold pl-0"> 화면 경로 선택</font>’ 버튼을 클릭해주세요.
          </li>
          <li>
            <font class="font-weight-bold pl-0">registration 폴더</font>에 있는 <font class="font-weight-bold pl-0">index.html</font>을
            선택하신 후 ‘ <font class="font-weight-bold pl-0">추가 </font>’ 버튼을 클릭해주세요.
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row class="pl-0">
      <v-col class="pl-0">
        <v-img :src="guidImgPc1" frameborder="0" style="max-width:1335px;"></v-img>
      </v-col>
    </v-row>
  </div>
</template>
<style scoped>
ul {
  list-style-type: decimal;
}

ul li {
  font-size: 0.9em;
}
</style>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../store";

export default {
  data() {
    return {
      description: "",
      fileCopy: "registration/index.html",
      sourceCopy: "",
      urlCopy: "https://" + store.state.mallId + ".cafe24.com/registration/index.html",
      guidImgPc1: require("../../../assets/authservice/images/designguide1_pc.png"),
    };
  },
  components: {},
  mixins: [CommonMixin],
  methods: {
    setDesign: async function(design_type) {
      try {
        const set_data = {
          apply_type: design_type,
          extension: {
            path: "index.html",
            add_file: "/authservice/etc/userfront/registration/index.html",
            position: "prepend",
          },
          files: [
            {
              from: "/authservice/etc/userfront/registration/index.html",
              to: "/registration/index.html",
            },
            {
              from: "/authservice/etc/userfront/registration/cafe24_cert_product.css",
              to: "/registration/css/cafe24_cert_product.css",
            },
            {
              from: "/authservice/etc/userfront/registration/cafe24_cert_product.js",
              to: "/registration/js/cafe24_cert_product.js",
            },
            {
              from: "/authservice/etc/userfront/registration/cert_product_transfer.js",
              to: "/registration/js/cert_product_transfer.js",
            },
          ],
        };
        const result = await M.api(M.entry("/put/design"), set_data);
        console.log(result.length, "design result");
        if (result.length > 0) {
          if (result.length == 4) {
            alert(
              "쇼핑몰에 정품 인증 화면이 생성되었습니다.\n쇼핑몰 도메인/registration/index.html\n경로로 사용하실 수 있습니다.\n쇼핑몰 메뉴,배너등 링크를 연결하여 사용하세요."
            );
          } else {
            const make_file = result.map((item) => item.path).join("\n");
            alert(`정품 인증 화면이 생성되었습니다. \nregistration 폴더에\n${make_file}\n파일이 생성되었으니 참고해주세요.`);
          }
        } else {
          alert("쇼핑몰에 정품 인증 화면이 생성되어 있습니다.\n(파일 위치 : 디자인 편집창 - registration 폴더)설정되었습니다.");
        }
      } catch (e) {
        console.log("design set error", e);

        alert("설정 실패했습니다.");
        this.memoDialog = false;
      }
    },
  },
  created: function() {
    if (sessionStorage.getItem(`${this.$store.state.mallId}_domain`)) {
      this.urlCopy = "https://" + sessionStorage.getItem(`${this.$store.state.mallId}_domain`) + "/registration/index.html";
    }
  },
};
</script>
